// Assistant policy (#16): every member of a tenant may call a model (the plan's limits, checked by
// the assistant context before the call, decide how much); the tenant's usage and cost — every
// person's — is for its admins, the people who own the spend (design standard DS-COST).
import { isMember, isRole } from '../policy/rules.js';
export const assistantPolicy = {
    kind: 'assistant',
    scope: 'tenant',
    actions: {
        converse: isMember,
        'read-usage': isRole('TenantAdmin'),
    },
};
//# sourceMappingURL=assistant.js.map